import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledContainerProps {
  theme: any;
  $borderRadius: number;
  $borderWidth: number;
  $themeCustom: any;
  $themeColor: string | null | undefined;
  $useThemeColor: boolean | null | undefined;
}
export const StyledContainer = styled.div<StyledContainerProps>`
  margin: 20px;
  background-color: ${({ theme, $themeCustom, $themeColor, $useThemeColor }) =>
    $themeCustom && $themeCustom.details.buttons.color
      ? $themeCustom.details.buttons.color
      : $useThemeColor
        ? $themeColor
        : theme.framed_background || theme.button_color || '#34b076'};
  border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
  border: ${({ $borderWidth, theme, $themeCustom, $themeColor, $useThemeColor }) =>
    `${$borderWidth}px solid ${$themeCustom && $themeCustom.details.buttons.color ? $themeCustom.details.buttons.color : $useThemeColor ? $themeColor : theme.framed_background || theme.button_color || '#34b076'}`};
  color: ${({ theme }) => theme.framed_background_text || 'white'};
  padding: 25px;
  ${({ theme }) => theme.framed_text_centered && 'text-align: center'};

  p {
    margin: 0 !important;
    padding: 5px;
    line-height: 20px;
  }
  ol {
    margin-left: ${({ theme }) => (theme.text_margin_left ? pxToRem(theme.text_margin_left) : '40px')};
    list-style-type: ${({ theme }) => (theme.text_list_style_type ? theme.text_list_style_type : 'decimal')};
  }
  ul {
    margin-left: ${({ theme }) => (theme.text_margin_left ? pxToRem(theme.text_margin_left) : '40px')};
    list-style-type: ${({ theme }) => (theme.text_list_style_type ? theme.text_list_style_type : 'disc')};
  }
  a {
    text-decoration: ${({ theme }) =>
      theme.text_text_decoration ? theme.text_text_decoration : 'underline'};
  }
`

interface StyledOutlinedContainerProps {
    theme: any;
    $borderRadius: number;
    $borderWidth: number;
    $themeCustom: any;
    $themeColor: string | null | undefined;
    $useThemeColor: boolean | null | undefined;
}
export const StyledOutlinedContainer = styled.div<StyledOutlinedContainerProps>`
  margin: 20px;
  border: ${({ $borderWidth, theme, $themeCustom, $themeColor, $useThemeColor }) =>
    `${$borderWidth}px solid ${$themeCustom && $themeCustom.details.buttons.color ? $themeCustom.details.buttons.color : $useThemeColor ? $themeColor : theme.framed_background || theme.button_color || '#34b076'}`};
  border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
  color: black;
  padding: 25px;
  ${({ theme }) => theme.framed_text_centered && 'text-align: center'};

  p {
    margin: 0 !important;
    padding: 5px;
    line-height: 20px;
    color: ${({ theme }) => theme.text_color || '#000000'};
  }
  ol {
    margin-left: ${({ theme }) => (theme.text_margin_left ? pxToRem(theme.text_margin_left) : '40px')};
    list-style-type: ${({ theme }) => (theme.text_list_style_type ? theme.text_list_style_type : 'decimal')};
  }
  ul {
    margin-left: ${({ theme }) => (theme.text_margin_left ? pxToRem(theme.text_margin_left) : '40px')};
    list-style-type: ${({ theme }) => (theme.text_list_style_type ? theme.text_list_style_type : 'disc')};
  }
  a {
    text-decoration: ${({ theme }) =>
      theme.text_text_decoration ? theme.text_text_decoration : 'underline'};
  }
`
